import React from 'react';
import bg from '../assets/images/headerBg.jpeg';
import VisibilitySensor from 'react-visibility-sensor';
import CountUp from 'react-countup';
const Countdown = () => {
  return (
    <div
      className='w-full h-[auto] object-cover bg-no-repeat'
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className='w-full h-full bg-[rgba(4,26,70,0.5)] flex justify-center items-center flex-wrap gap-[16px] py-[23px]'>
        <div
          className='flex justify-center items-center flex-col gap-[13px] w-[75%] sm:w-[30%] h-[250px] rounded-[30px] bg-[rgba(0,0,0,0.4)]'
          data-aos='fade-left'
        >
          <p className='text-[43px] font-bolder leading-[34px] text-[rgb(255,189,57)]'>
            {' '}
            <CountUp
              start={0}
              end={5000}
              duration={2.75}
              separator=', '
              // decimals={4}
              decimal=','
            >
              {({ countUpRef, start }) => (
                <VisibilitySensor onChange={start}>
                  <div>
                    <span ref={countUpRef} />
                    <sup>+</sup>{' '}
                  </div>
                </VisibilitySensor>
              )}
            </CountUp>
          </p>
          <p className='text-[18px] font-bold text-white'>
            {' '}
            Skills based placement{' '}
          </p>
        </div>
        <div className='flex justify-center items-center flex-col gap-[13px] w-[75%] sm:w-[30%] h-[250px] rounded-[30px] bg-[rgba(0,0,0,0.4)]'>
          <p
            className='text-[43px] font-bolder leading-[34px] text-[rgb(255,189,57)]'
            data-aos='fade-left'
          >
            {' '}
            <CountUp
              start={0}
              end={25000}
              duration={2.75}
              separator=', '
              // decimals={4}
              decimal=','
            >
              {({ countUpRef, start }) => (
                <VisibilitySensor onChange={start}>
                  <div>
                    <span ref={countUpRef} />
                    <sup>+</sup>{' '}
                  </div>
                </VisibilitySensor>
              )}
            </CountUp>
          </p>
          <p className='text-[18px] font-bold text-white'>
            {' '}
            Industry Certified{' '}
          </p>
        </div>
        <div
          className='flex justify-center items-center flex-col gap-[13px] w-[75%] sm:w-[30%] h-[250px] rounded-[30px] bg-[rgba(0,0,0,0.4)]'
          data-aos='fade-left'
        >
          <p className='text-[43px] font-bolder leading-[34px] text-[rgb(255,189,57)]'>
            {' '}
            <CountUp
              start={0}
              end={375000}
              duration={2.75}
              separator=', '
              // decimals={4}
              decimal=','
            >
              {({ countUpRef, start }) => (
                <VisibilitySensor onChange={start}>
                  <div>
                    <span ref={countUpRef} />
                    <sup>+</sup>{' '}
                  </div>
                </VisibilitySensor>
              )}
            </CountUp>
          </p>
          <p className='text-[18px] font-bold text-white'> Platform Users </p>
        </div>
        <div
          className='flex justify-center items-center flex-col gap-[13px] w-[75%] sm:w-[30%] h-[250px] rounded-[30px] bg-[rgba(0,0,0,0.4)]'
          data-aos='fade-left'
        >
          <p className='text-[43px] font-bolder leading-[34px] text-[rgb(255,189,57)]'>
            {' '}
            <CountUp
              start={0}
              end={15}
              duration={2.75}
              separator=', '
              redraw='true'
              decimal=','
            >
              {({ countUpRef, start }) => (
                <VisibilitySensor onChange={start}>
                  <div>
                    <span ref={countUpRef} />
                    <sup>+</sup>{' '}
                  </div>
                </VisibilitySensor>
              )}
            </CountUp>
          </p>
          <p className='text-[18px] font-bold text-white'>
            {' '}
            Implementing Partners{' '}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
